/**
 * Do not edit directly, this file was auto-generated.
 */

export default {
  primitives: {
    color: {
      primary: {
        100: {
          key: "{primitives.color.primary.100}",
          $type: "color",
          $value: "#a2a8cb",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#a2a8cb",
            key: "{primitives.color.primary.100}",
          },
          name: "PrimitivesColorPrimary100",
          attributes: {
            category: "primitives",
            type: "color",
            item: "primary",
            subitem: "100",
          },
          path: ["primitives", "color", "primary", "100"],
        },
        200: {
          key: "{primitives.color.primary.200}",
          $type: "color",
          $value: "#737db1",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#737db1",
            key: "{primitives.color.primary.200}",
          },
          name: "PrimitivesColorPrimary200",
          attributes: {
            category: "primitives",
            type: "color",
            item: "primary",
            subitem: "200",
          },
          path: ["primitives", "color", "primary", "200"],
        },
        300: {
          key: "{primitives.color.primary.300}",
          $type: "color",
          $value: "#545a89",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#545a89",
            key: "{primitives.color.primary.300}",
          },
          name: "PrimitivesColorPrimary300",
          attributes: {
            category: "primitives",
            type: "color",
            item: "primary",
            subitem: "300",
          },
          path: ["primitives", "color", "primary", "300"],
        },
        400: {
          key: "{primitives.color.primary.400}",
          $type: "color",
          $value: "#455197",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#455197",
            key: "{primitives.color.primary.400}",
          },
          name: "PrimitivesColorPrimary400",
          attributes: {
            category: "primitives",
            type: "color",
            item: "primary",
            subitem: "400",
          },
          path: ["primitives", "color", "primary", "400"],
        },
        500: {
          key: "{primitives.color.primary.500}",
          $type: "color",
          $value: "#16267d",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#16267d",
            key: "{primitives.color.primary.500}",
          },
          name: "PrimitivesColorPrimary500",
          attributes: {
            category: "primitives",
            type: "color",
            item: "primary",
            subitem: "500",
          },
          path: ["primitives", "color", "primary", "500"],
        },
        600: {
          key: "{primitives.color.primary.600}",
          $type: "color",
          $value: "#121e64",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#121e64",
            key: "{primitives.color.primary.600}",
          },
          name: "PrimitivesColorPrimary600",
          attributes: {
            category: "primitives",
            type: "color",
            item: "primary",
            subitem: "600",
          },
          path: ["primitives", "color", "primary", "600"],
        },
      },
      secondary: {
        100: {
          key: "{primitives.color.secondary.100}",
          $type: "color",
          $value: "#fefbe8",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#fefbe8",
            key: "{primitives.color.secondary.100}",
          },
          name: "PrimitivesColorSecondary100",
          attributes: {
            category: "primitives",
            type: "color",
            item: "secondary",
            subitem: "100",
          },
          path: ["primitives", "color", "secondary", "100"],
        },
        200: {
          key: "{primitives.color.secondary.200}",
          $type: "color",
          $value: "#fee49b",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#fee49b",
            key: "{primitives.color.secondary.200}",
          },
          name: "PrimitivesColorSecondary200",
          attributes: {
            category: "primitives",
            type: "color",
            item: "secondary",
            subitem: "200",
          },
          path: ["primitives", "color", "secondary", "200"],
        },
        300: {
          key: "{primitives.color.secondary.300}",
          $type: "color",
          $value: "#fed768",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#fed768",
            key: "{primitives.color.secondary.300}",
          },
          name: "PrimitivesColorSecondary300",
          attributes: {
            category: "primitives",
            type: "color",
            item: "secondary",
            subitem: "300",
          },
          path: ["primitives", "color", "secondary", "300"],
        },
        400: {
          key: "{primitives.color.secondary.400}",
          $type: "color",
          $value: "#fdc936",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#fdc936",
            key: "{primitives.color.secondary.400}",
          },
          name: "PrimitivesColorSecondary400",
          attributes: {
            category: "primitives",
            type: "color",
            item: "secondary",
            subitem: "400",
          },
          path: ["primitives", "color", "secondary", "400"],
        },
        500: {
          key: "{primitives.color.secondary.500}",
          $type: "color",
          $value: "#fdbc04",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#fdbc04",
            key: "{primitives.color.secondary.500}",
          },
          name: "PrimitivesColorSecondary500",
          attributes: {
            category: "primitives",
            type: "color",
            item: "secondary",
            subitem: "500",
          },
          path: ["primitives", "color", "secondary", "500"],
        },
        600: {
          key: "{primitives.color.secondary.600}",
          $type: "color",
          $value: "#e5ab06",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#e5ab06",
            key: "{primitives.color.secondary.600}",
          },
          name: "PrimitivesColorSecondary600",
          attributes: {
            category: "primitives",
            type: "color",
            item: "secondary",
            subitem: "600",
          },
          path: ["primitives", "color", "secondary", "600"],
        },
        700: {
          key: "{primitives.color.secondary.700}",
          $type: "color",
          $value: "#c17f04",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#c17f04",
            key: "{primitives.color.secondary.700}",
          },
          name: "PrimitivesColorSecondary700",
          attributes: {
            category: "primitives",
            type: "color",
            item: "secondary",
            subitem: "700",
          },
          path: ["primitives", "color", "secondary", "700"],
        },
      },
      tertiary: {
        100: {
          key: "{primitives.color.tertiary.100}",
          $type: "color",
          $value: "#f8f9fc",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#f8f9fc",
            key: "{primitives.color.tertiary.100}",
          },
          name: "PrimitivesColorTertiary100",
          attributes: {
            category: "primitives",
            type: "color",
            item: "tertiary",
            subitem: "100",
          },
          path: ["primitives", "color", "tertiary", "100"],
        },
        200: {
          key: "{primitives.color.tertiary.200}",
          $type: "color",
          $value: "#d3dceb",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#d3dceb",
            key: "{primitives.color.tertiary.200}",
          },
          name: "PrimitivesColorTertiary200",
          attributes: {
            category: "primitives",
            type: "color",
            item: "tertiary",
            subitem: "200",
          },
          path: ["primitives", "color", "tertiary", "200"],
        },
        300: {
          key: "{primitives.color.tertiary.300}",
          $type: "color",
          $value: "#aebbd1",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#aebbd1",
            key: "{primitives.color.tertiary.300}",
          },
          name: "PrimitivesColorTertiary300",
          attributes: {
            category: "primitives",
            type: "color",
            item: "tertiary",
            subitem: "300",
          },
          path: ["primitives", "color", "tertiary", "300"],
        },
        400: {
          key: "{primitives.color.tertiary.400}",
          $type: "color",
          $value: "#667085",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#667085",
            key: "{primitives.color.tertiary.400}",
          },
          name: "PrimitivesColorTertiary400",
          attributes: {
            category: "primitives",
            type: "color",
            item: "tertiary",
            subitem: "400",
          },
          path: ["primitives", "color", "tertiary", "400"],
        },
        500: {
          key: "{primitives.color.tertiary.500}",
          $type: "color",
          $value: "#2b3a4b",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#2b3a4b",
            key: "{primitives.color.tertiary.500}",
          },
          name: "PrimitivesColorTertiary500",
          attributes: {
            category: "primitives",
            type: "color",
            item: "tertiary",
            subitem: "500",
          },
          path: ["primitives", "color", "tertiary", "500"],
        },
        600: {
          key: "{primitives.color.tertiary.600}",
          $type: "color",
          $value: "#1b1f3b",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#1b1f3b",
            key: "{primitives.color.tertiary.600}",
          },
          name: "PrimitivesColorTertiary600",
          attributes: {
            category: "primitives",
            type: "color",
            item: "tertiary",
            subitem: "600",
          },
          path: ["primitives", "color", "tertiary", "600"],
        },
        700: {
          key: "{primitives.color.tertiary.700}",
          $type: "color",
          $value: "#13162a",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#13162a",
            key: "{primitives.color.tertiary.700}",
          },
          name: "PrimitivesColorTertiary700",
          attributes: {
            category: "primitives",
            type: "color",
            item: "tertiary",
            subitem: "700",
          },
          path: ["primitives", "color", "tertiary", "700"],
        },
      },
      background: {
        100: {
          key: "{primitives.color.background.100}",
          $type: "color",
          $value: "#ffffff",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#ffffff",
            key: "{primitives.color.background.100}",
          },
          name: "PrimitivesColorBackground100",
          attributes: {
            category: "primitives",
            type: "color",
            item: "background",
            subitem: "100",
          },
          path: ["primitives", "color", "background", "100"],
        },
        200: {
          key: "{primitives.color.background.200}",
          $type: "color",
          $value: "#f9fafb",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#f9fafb",
            key: "{primitives.color.background.200}",
          },
          name: "PrimitivesColorBackground200",
          attributes: {
            category: "primitives",
            type: "color",
            item: "background",
            subitem: "200",
          },
          path: ["primitives", "color", "background", "200"],
        },
        300: {
          key: "{primitives.color.background.300}",
          $type: "color",
          $value: "#f1f7ff",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#f1f7ff",
            key: "{primitives.color.background.300}",
          },
          name: "PrimitivesColorBackground300",
          attributes: {
            category: "primitives",
            type: "color",
            item: "background",
            subitem: "300",
          },
          path: ["primitives", "color", "background", "300"],
        },
      },
      red: {
        100: {
          key: "{primitives.color.red.100}",
          $type: "color",
          $value: "#f77a4a",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#f77a4a",
            key: "{primitives.color.red.100}",
          },
          name: "PrimitivesColorRed100",
          attributes: {
            category: "primitives",
            type: "color",
            item: "red",
            subitem: "100",
          },
          path: ["primitives", "color", "red", "100"],
        },
        200: {
          key: "{primitives.color.red.200}",
          $type: "color",
          $value: "#f87171",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#f87171",
            key: "{primitives.color.red.200}",
          },
          name: "PrimitivesColorRed200",
          attributes: {
            category: "primitives",
            type: "color",
            item: "red",
            subitem: "200",
          },
          path: ["primitives", "color", "red", "200"],
        },
        300: {
          key: "{primitives.color.red.300}",
          $type: "color",
          $value: "#d70b00",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#d70b00",
            key: "{primitives.color.red.300}",
          },
          name: "PrimitivesColorRed300",
          attributes: {
            category: "primitives",
            type: "color",
            item: "red",
            subitem: "300",
          },
          path: ["primitives", "color", "red", "300"],
        },
      },
      green: {
        100: {
          key: "{primitives.color.green.100}",
          $type: "color",
          $value: "#e6fdee",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#e6fdee",
            key: "{primitives.color.green.100}",
          },
          name: "PrimitivesColorGreen100",
          attributes: {
            category: "primitives",
            type: "color",
            item: "green",
            subitem: "100",
          },
          path: ["primitives", "color", "green", "100"],
        },
        200: {
          key: "{primitives.color.green.200}",
          $type: "color",
          $value: "#28a745",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#28a745",
            key: "{primitives.color.green.200}",
          },
          name: "PrimitivesColorGreen200",
          attributes: {
            category: "primitives",
            type: "color",
            item: "green",
            subitem: "200",
          },
          path: ["primitives", "color", "green", "200"],
        },
        300: {
          key: "{primitives.color.green.300}",
          $type: "color",
          $value: "#15803d",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#15803d",
            key: "{primitives.color.green.300}",
          },
          name: "PrimitivesColorGreen300",
          attributes: {
            category: "primitives",
            type: "color",
            item: "green",
            subitem: "300",
          },
          path: ["primitives", "color", "green", "300"],
        },
        400: {
          key: "{primitives.color.green.400}",
          $type: "color",
          $value: "#005248",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#005248",
            key: "{primitives.color.green.400}",
          },
          name: "PrimitivesColorGreen400",
          attributes: {
            category: "primitives",
            type: "color",
            item: "green",
            subitem: "400",
          },
          path: ["primitives", "color", "green", "400"],
        },
        500: {
          key: "{primitives.color.green.500}",
          $type: "color",
          $value: "#00685b",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#00685b",
            key: "{primitives.color.green.500}",
          },
          name: "PrimitivesColorGreen500",
          attributes: {
            category: "primitives",
            type: "color",
            item: "green",
            subitem: "500",
          },
          path: ["primitives", "color", "green", "500"],
        },
        600: {
          key: "{primitives.color.green.600}",
          $type: "color",
          $value: "#78c7bd",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#78c7bd",
            key: "{primitives.color.green.600}",
          },
          name: "PrimitivesColorGreen600",
          attributes: {
            category: "primitives",
            type: "color",
            item: "green",
            subitem: "600",
          },
          path: ["primitives", "color", "green", "600"],
        },
        700: {
          key: "{primitives.color.green.700}",
          $type: "color",
          $value: "#00a63e",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#00a63e",
            key: "{primitives.color.green.700}",
          },
          name: "PrimitivesColorGreen700",
          attributes: {
            category: "primitives",
            type: "color",
            item: "green",
            subitem: "700",
          },
          path: ["primitives", "color", "green", "700"],
        },
      },
      blue: {
        100: {
          key: "{primitives.color.blue.100}",
          $type: "color",
          $value: "#d3ecf9",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#d3ecf9",
            key: "{primitives.color.blue.100}",
          },
          name: "PrimitivesColorBlue100",
          attributes: {
            category: "primitives",
            type: "color",
            item: "blue",
            subitem: "100",
          },
          path: ["primitives", "color", "blue", "100"],
        },
        200: {
          key: "{primitives.color.blue.200}",
          $type: "color",
          $value: "#bedeec",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#bedeec",
            key: "{primitives.color.blue.200}",
          },
          name: "PrimitivesColorBlue200",
          attributes: {
            category: "primitives",
            type: "color",
            item: "blue",
            subitem: "200",
          },
          path: ["primitives", "color", "blue", "200"],
        },
        300: {
          key: "{primitives.color.blue.300}",
          $type: "color",
          $value: "#1570ef",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#1570ef",
            key: "{primitives.color.blue.300}",
          },
          name: "PrimitivesColorBlue300",
          attributes: {
            category: "primitives",
            type: "color",
            item: "blue",
            subitem: "300",
          },
          path: ["primitives", "color", "blue", "300"],
        },
        400: {
          key: "{primitives.color.blue.400}",
          $type: "color",
          $value: "#10a4c4",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#10a4c4",
            key: "{primitives.color.blue.400}",
          },
          name: "PrimitivesColorBlue400",
          attributes: {
            category: "primitives",
            type: "color",
            item: "blue",
            subitem: "400",
          },
          path: ["primitives", "color", "blue", "400"],
        },
        500: {
          key: "{primitives.color.blue.500}",
          $type: "color",
          $value: "#9bd2e8",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#9bd2e8",
            key: "{primitives.color.blue.500}",
          },
          name: "PrimitivesColorBlue500",
          attributes: {
            category: "primitives",
            type: "color",
            item: "blue",
            subitem: "500",
          },
          path: ["primitives", "color", "blue", "500"],
        },
        600: {
          key: "{primitives.color.blue.600}",
          $type: "color",
          $value: "#224d92",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#224d92",
            key: "{primitives.color.blue.600}",
          },
          name: "PrimitivesColorBlue600",
          attributes: {
            category: "primitives",
            type: "color",
            item: "blue",
            subitem: "600",
          },
          path: ["primitives", "color", "blue", "600"],
        },
        700: {
          key: "{primitives.color.blue.700}",
          $type: "color",
          $value: "#545a89",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#545a89",
            key: "{primitives.color.blue.700}",
          },
          name: "PrimitivesColorBlue700",
          attributes: {
            category: "primitives",
            type: "color",
            item: "blue",
            subitem: "700",
          },
          path: ["primitives", "color", "blue", "700"],
        },
        800: {
          key: "{primitives.color.blue.800}",
          $type: "color",
          $value: "#99c0f5",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#99c0f5",
            key: "{primitives.color.blue.800}",
          },
          name: "PrimitivesColorBlue800",
          attributes: {
            category: "primitives",
            type: "color",
            item: "blue",
            subitem: "800",
          },
          path: ["primitives", "color", "blue", "800"],
        },
      },
      purple: {
        100: {
          key: "{primitives.color.purple.100}",
          $type: "color",
          $value: "#ac3c86",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#ac3c86",
            key: "{primitives.color.purple.100}",
          },
          name: "PrimitivesColorPurple100",
          attributes: {
            category: "primitives",
            type: "color",
            item: "purple",
            subitem: "100",
          },
          path: ["primitives", "color", "purple", "100"],
        },
        200: {
          key: "{primitives.color.purple.200}",
          $type: "color",
          $value: "#dd9fc8",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#dd9fc8",
            key: "{primitives.color.purple.200}",
          },
          name: "PrimitivesColorPurple200",
          attributes: {
            category: "primitives",
            type: "color",
            item: "purple",
            subitem: "200",
          },
          path: ["primitives", "color", "purple", "200"],
        },
      },
      border: {
        100: {
          key: "{primitives.color.border.100}",
          $type: "color",
          $value: "#f2f4fa",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#f2f4fa",
            key: "{primitives.color.border.100}",
          },
          name: "PrimitivesColorBorder100",
          attributes: {
            category: "primitives",
            type: "color",
            item: "border",
            subitem: "100",
          },
          path: ["primitives", "color", "border", "100"],
        },
        200: {
          key: "{primitives.color.border.200}",
          $type: "color",
          $value: "#e4e6eb",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#e4e6eb",
            key: "{primitives.color.border.200}",
          },
          name: "PrimitivesColorBorder200",
          attributes: {
            category: "primitives",
            type: "color",
            item: "border",
            subitem: "200",
          },
          path: ["primitives", "color", "border", "200"],
        },
        300: {
          key: "{primitives.color.border.300}",
          $type: "color",
          $value: "#bedeec",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#bedeec",
            key: "{primitives.color.border.300}",
          },
          name: "PrimitivesColorBorder300",
          attributes: {
            category: "primitives",
            type: "color",
            item: "border",
            subitem: "300",
          },
          path: ["primitives", "color", "border", "300"],
        },
      },
    },
  },
  sizing: {
    xxs: {
      key: "{sizing.xxs}",
      $type: "dimension",
      $value: "8px",
      filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
      isSource: true,
      original: {
        $type: "dimension",
        $value: "8px",
        key: "{sizing.xxs}",
      },
      name: "SizingXxs",
      attributes: {
        category: "sizing",
        type: "xxs",
      },
      path: ["sizing", "xxs"],
    },
    xs: {
      key: "{sizing.xs}",
      $type: "dimension",
      $value: "12px",
      filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
      isSource: true,
      original: {
        $type: "dimension",
        $value: "12px",
        key: "{sizing.xs}",
      },
      name: "SizingXs",
      attributes: {
        category: "sizing",
        type: "xs",
      },
      path: ["sizing", "xs"],
    },
    sm: {
      key: "{sizing.sm}",
      $type: "dimension",
      $value: "16px",
      filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
      isSource: true,
      original: {
        $type: "dimension",
        $value: "16px",
        key: "{sizing.sm}",
      },
      name: "SizingSm",
      attributes: {
        category: "sizing",
        type: "sm",
      },
      path: ["sizing", "sm"],
    },
    md: {
      key: "{sizing.md}",
      $type: "dimension",
      $value: "20px",
      filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
      isSource: true,
      original: {
        $type: "dimension",
        $value: "20px",
        key: "{sizing.md}",
      },
      name: "SizingMd",
      attributes: {
        category: "sizing",
        type: "md",
      },
      path: ["sizing", "md"],
    },
    lg: {
      key: "{sizing.lg}",
      $type: "dimension",
      $value: "24px",
      filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
      isSource: true,
      original: {
        $type: "dimension",
        $value: "24px",
        key: "{sizing.lg}",
      },
      name: "SizingLg",
      attributes: {
        category: "sizing",
        type: "lg",
      },
      path: ["sizing", "lg"],
    },
    xl: {
      key: "{sizing.xl}",
      $type: "dimension",
      $value: "32px",
      filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
      isSource: true,
      original: {
        $type: "dimension",
        $value: "32px",
        key: "{sizing.xl}",
      },
      name: "SizingXl",
      attributes: {
        category: "sizing",
        type: "xl",
      },
      path: ["sizing", "xl"],
    },
    xxl: {
      key: "{sizing.xxl}",
      $type: "dimension",
      $value: "36px",
      filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
      isSource: true,
      original: {
        $type: "dimension",
        $value: "36px",
        key: "{sizing.xxl}",
      },
      name: "SizingXxl",
      attributes: {
        category: "sizing",
        type: "xxl",
      },
      path: ["sizing", "xxl"],
    },
    xxxl: {
      key: "{sizing.xxxl}",
      $type: "dimension",
      $value: "48px",
      filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
      isSource: true,
      original: {
        $type: "dimension",
        $value: "48px",
        key: "{sizing.xxxl}",
      },
      name: "SizingXxxl",
      attributes: {
        category: "sizing",
        type: "xxxl",
      },
      path: ["sizing", "xxxl"],
    },
    xxxs: {
      key: "{sizing.xxxs}",
      $type: "dimension",
      $value: "4px",
      filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
      isSource: true,
      original: {
        $type: "dimension",
        $value: "4px",
        key: "{sizing.xxxs}",
      },
      name: "SizingXxxs",
      attributes: {
        category: "sizing",
        type: "xxxs",
      },
      path: ["sizing", "xxxs"],
    },
  },
  typography: {
    Display: {
      key: "{typography.Display}",
      $type: "string",
      $value: "String value",
      filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
      isSource: true,
      original: {
        $type: "string",
        $value: "String value",
        key: "{typography.Display}",
      },
      name: "TypographyDisplay",
      attributes: {
        category: "typography",
        type: "Display",
      },
      path: ["typography", "Display"],
    },
  },
  tokens: {
    color: {
      background: {
        primary: {
          key: "{tokens.color.background.primary}",
          $type: "color",
          $value: "#ffffff",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "{primitives.color.background.100}",
            key: "{tokens.color.background.primary}",
          },
          name: "TokensColorBackgroundPrimary",
          attributes: {
            category: "tokens",
            type: "color",
            item: "background",
            subitem: "primary",
          },
          path: ["tokens", "color", "background", "primary"],
        },
        secondary: {
          key: "{tokens.color.background.secondary}",
          $type: "color",
          $value: "#f9fafb",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "{primitives.color.background.200}",
            key: "{tokens.color.background.secondary}",
          },
          name: "TokensColorBackgroundSecondary",
          attributes: {
            category: "tokens",
            type: "color",
            item: "background",
            subitem: "secondary",
          },
          path: ["tokens", "color", "background", "secondary"],
        },
        tertiary: {
          key: "{tokens.color.background.tertiary}",
          $type: "color",
          $value: "#f1f7ff",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "{primitives.color.background.300}",
            key: "{tokens.color.background.tertiary}",
          },
          name: "TokensColorBackgroundTertiary",
          attributes: {
            category: "tokens",
            type: "color",
            item: "background",
            subitem: "tertiary",
          },
          path: ["tokens", "color", "background", "tertiary"],
        },
      },
      border: {
        light: {
          key: "{tokens.color.border.light}",
          $type: "color",
          $value: "#f2f4fa",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "{primitives.color.border.100}",
            key: "{tokens.color.border.light}",
          },
          name: "TokensColorBorderLight",
          attributes: {
            category: "tokens",
            type: "color",
            item: "border",
            subitem: "light",
          },
          path: ["tokens", "color", "border", "light"],
        },
        dark: {
          key: "{tokens.color.border.dark}",
          $type: "color",
          $value: "#e4e6eb",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "{primitives.color.border.200}",
            key: "{tokens.color.border.dark}",
          },
          name: "TokensColorBorderDark",
          attributes: {
            category: "tokens",
            type: "color",
            item: "border",
            subitem: "dark",
          },
          path: ["tokens", "color", "border", "dark"],
        },
      },
      foreground: {
        primary: {
          key: "{tokens.color.foreground.primary}",
          $type: "color",
          $value: "#ffffff",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#ffffff",
            key: "{tokens.color.foreground.primary}",
          },
          name: "TokensColorForegroundPrimary",
          attributes: {
            category: "tokens",
            type: "color",
            item: "foreground",
            subitem: "primary",
          },
          path: ["tokens", "color", "foreground", "primary"],
        },
        primary_2: {
          key: "{tokens.color.foreground.primary_2}",
          $type: "color",
          $value: "#ffffff",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#ffffff",
            key: "{tokens.color.foreground.primary_2}",
          },
          name: "TokensColorForegroundPrimary2",
          attributes: {
            category: "tokens",
            type: "color",
            item: "foreground",
            subitem: "primary_2",
          },
          path: ["tokens", "color", "foreground", "primary_2"],
        },
        primary_3: {
          key: "{tokens.color.foreground.primary_3}",
          $type: "color",
          $value: "#ffffff",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "#ffffff",
            key: "{tokens.color.foreground.primary_3}",
          },
          name: "TokensColorForegroundPrimary3",
          attributes: {
            category: "tokens",
            type: "color",
            item: "foreground",
            subitem: "primary_3",
          },
          path: ["tokens", "color", "foreground", "primary_3"],
        },
      },
      charts: {
        emerald: {
          key: "{tokens.color.charts.emerald}",
          $type: "color",
          $value: "#00685b",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "{primitives.color.green.500}",
            key: "{tokens.color.charts.emerald}",
          },
          name: "TokensColorChartsEmerald",
          attributes: {
            category: "tokens",
            type: "color",
            item: "charts",
            subitem: "emerald",
          },
          path: ["tokens", "color", "charts", "emerald"],
        },
        emerald_light: {
          key: "{tokens.color.charts.emerald_light}",
          $type: "color",
          $value: "#78c7bd",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "{primitives.color.green.600}",
            key: "{tokens.color.charts.emerald_light}",
          },
          name: "TokensColorChartsEmeraldLight",
          attributes: {
            category: "tokens",
            type: "color",
            item: "charts",
            subitem: "emerald_light",
          },
          path: ["tokens", "color", "charts", "emerald_light"],
        },
        emerald_dark: {
          key: "{tokens.color.charts.emerald_dark}",
          $type: "color",
          $value: "#005248",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "{primitives.color.green.400}",
            key: "{tokens.color.charts.emerald_dark}",
          },
          name: "TokensColorChartsEmeraldDark",
          attributes: {
            category: "tokens",
            type: "color",
            item: "charts",
            subitem: "emerald_dark",
          },
          path: ["tokens", "color", "charts", "emerald_dark"],
        },
        orange: {
          key: "{tokens.color.charts.orange}",
          $type: "color",
          $value: "#f77a4a",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "{primitives.color.red.100}",
            key: "{tokens.color.charts.orange}",
          },
          name: "TokensColorChartsOrange",
          attributes: {
            category: "tokens",
            type: "color",
            item: "charts",
            subitem: "orange",
          },
          path: ["tokens", "color", "charts", "orange"],
        },
        gold: {
          key: "{tokens.color.charts.gold}",
          $type: "color",
          $value: "#e5ab06",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "{primitives.color.secondary.600}",
            key: "{tokens.color.charts.gold}",
          },
          name: "TokensColorChartsGold",
          attributes: {
            category: "tokens",
            type: "color",
            item: "charts",
            subitem: "gold",
          },
          path: ["tokens", "color", "charts", "gold"],
        },
        gold_light: {
          key: "{tokens.color.charts.gold_light}",
          $type: "color",
          $value: "#fed768",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "{primitives.color.secondary.300}",
            key: "{tokens.color.charts.gold_light}",
          },
          name: "TokensColorChartsGoldLight",
          attributes: {
            category: "tokens",
            type: "color",
            item: "charts",
            subitem: "gold_light",
          },
          path: ["tokens", "color", "charts", "gold_light"],
        },
        gold_dark: {
          key: "{tokens.color.charts.gold_dark}",
          $type: "color",
          $value: "#c17f04",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "{primitives.color.secondary.700}",
            key: "{tokens.color.charts.gold_dark}",
          },
          name: "TokensColorChartsGoldDark",
          attributes: {
            category: "tokens",
            type: "color",
            item: "charts",
            subitem: "gold_dark",
          },
          path: ["tokens", "color", "charts", "gold_dark"],
        },
        sapphire: {
          key: "{tokens.color.charts.sapphire}",
          $type: "color",
          $value: "#16267d",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "{primitives.color.primary.500}",
            key: "{tokens.color.charts.sapphire}",
          },
          name: "TokensColorChartsSapphire",
          attributes: {
            category: "tokens",
            type: "color",
            item: "charts",
            subitem: "sapphire",
          },
          path: ["tokens", "color", "charts", "sapphire"],
        },
        cerulean: {
          key: "{tokens.color.charts.cerulean}",
          $type: "color",
          $value: "#10a4c4",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "{primitives.color.blue.400}",
            key: "{tokens.color.charts.cerulean}",
          },
          name: "TokensColorChartsCerulean",
          attributes: {
            category: "tokens",
            type: "color",
            item: "charts",
            subitem: "cerulean",
          },
          path: ["tokens", "color", "charts", "cerulean"],
        },
        cerulean_light: {
          key: "{tokens.color.charts.cerulean_light}",
          $type: "color",
          $value: "#9bd2e8",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "{primitives.color.blue.500}",
            key: "{tokens.color.charts.cerulean_light}",
          },
          name: "TokensColorChartsCeruleanLight",
          attributes: {
            category: "tokens",
            type: "color",
            item: "charts",
            subitem: "cerulean_light",
          },
          path: ["tokens", "color", "charts", "cerulean_light"],
        },
        purple: {
          key: "{tokens.color.charts.purple}",
          $type: "color",
          $value: "#ac3c86",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "{primitives.color.purple.100}",
            key: "{tokens.color.charts.purple}",
          },
          name: "TokensColorChartsPurple",
          attributes: {
            category: "tokens",
            type: "color",
            item: "charts",
            subitem: "purple",
          },
          path: ["tokens", "color", "charts", "purple"],
        },
        purple_light: {
          key: "{tokens.color.charts.purple_light}",
          $type: "color",
          $value: "#dd9fc8",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "{primitives.color.purple.200}",
            key: "{tokens.color.charts.purple_light}",
          },
          name: "TokensColorChartsPurpleLight",
          attributes: {
            category: "tokens",
            type: "color",
            item: "charts",
            subitem: "purple_light",
          },
          path: ["tokens", "color", "charts", "purple_light"],
        },
        blue_dark: {
          key: "{tokens.color.charts.blue_dark}",
          $type: "color",
          $value: "#224d92",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "{primitives.color.blue.600}",
            key: "{tokens.color.charts.blue_dark}",
          },
          name: "TokensColorChartsBlueDark",
          attributes: {
            category: "tokens",
            type: "color",
            item: "charts",
            subitem: "blue_dark",
          },
          path: ["tokens", "color", "charts", "blue_dark"],
        },
        waikawa: {
          key: "{tokens.color.charts.waikawa}",
          $type: "color",
          $value: "#545a89",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "{primitives.color.blue.700}",
            key: "{tokens.color.charts.waikawa}",
          },
          name: "TokensColorChartsWaikawa",
          attributes: {
            category: "tokens",
            type: "color",
            item: "charts",
            subitem: "waikawa",
          },
          path: ["tokens", "color", "charts", "waikawa"],
        },
        jordy: {
          key: "{tokens.color.charts.jordy}",
          $type: "color",
          $value: "#99c0f5",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "{primitives.color.blue.800}",
            key: "{tokens.color.charts.jordy}",
          },
          name: "TokensColorChartsJordy",
          attributes: {
            category: "tokens",
            type: "color",
            item: "charts",
            subitem: "jordy",
          },
          path: ["tokens", "color", "charts", "jordy"],
        },
        const_green: {
          key: "{tokens.color.charts.const_green}",
          $type: "color",
          $value: "#00a63e",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "{primitives.color.green.700}",
            key: "{tokens.color.charts.const_green}",
          },
          name: "TokensColorChartsConstGreen",
          attributes: {
            category: "tokens",
            type: "color",
            item: "charts",
            subitem: "const_green",
          },
          path: ["tokens", "color", "charts", "const_green"],
        },
        yellow: {
          key: "{tokens.color.charts.yellow}",
          $type: "color",
          $value: "#fdc936",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "{primitives.color.secondary.400}",
            key: "{tokens.color.charts.yellow}",
          },
          name: "TokensColorChartsYellow",
          attributes: {
            category: "tokens",
            type: "color",
            item: "charts",
            subitem: "yellow",
          },
          path: ["tokens", "color", "charts", "yellow"],
        },
        blue: {
          key: "{tokens.color.charts.blue}",
          $type: "color",
          $value: "#1570ef",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "{primitives.color.blue.300}",
            key: "{tokens.color.charts.blue}",
          },
          name: "TokensColorChartsBlue",
          attributes: {
            category: "tokens",
            type: "color",
            item: "charts",
            subitem: "blue",
          },
          path: ["tokens", "color", "charts", "blue"],
        },
        navy: {
          key: "{tokens.color.charts.navy}",
          $type: "color",
          $value: "#1b1f3b",
          filePath: "node_modules/meshh-design-tokens/tokens/tokens.json",
          isSource: true,
          original: {
            $type: "color",
            $value: "{primitives.color.tertiary.600}",
            key: "{tokens.color.charts.navy}",
          },
          name: "TokensColorChartsNavy",
          attributes: {
            category: "tokens",
            type: "color",
            item: "charts",
            subitem: "navy",
          },
          path: ["tokens", "color", "charts", "navy"],
        },
      },
    },
  },
};
